export const eventTypesToPage = {
    backtest_complete: 'backtestResult',
    score_complete: 'strategyScore'
};